import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import media from '../../theme/media';
import { fontMono, fontSans } from '../../theme/config';
import { ContainerLarge } from '../../theme/grid';
import { LinkCustom } from '../../theme/typography';

const ArticleFooter = styled.div`
  display: none;
  
  &.false {
    display: none;
  }
  &.true {
    display: block;
  }
`;

const OverlayFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 88px;
    padding: 1.5rem 2rem;

    &.false {
      display: flex;
    }
    &.true {
      display: none;
    }
    
    &.mozilla {
      color: #ff0900;
      svg g {
        stroke: #ff0900;
      }
    }
    &.skwiz {
      color: #485CDC;
      svg g {
        stroke: #485CDC;
      }
    }
    &.everyaction {
      color: #0077FF;
      svg g {
        stroke: #0077FF;
      }
    }
    
    &.amazon {
      color: #f86b01;
      svg g {
        stroke: #f86b01;
      }
    }
    
    a {
        font-size: 20px;
        display: flex;
        align-items: center;
        font-weight: 700;
        span {
            padding: 0 .5rem;
        }
    }
    
    a.none {
      display: none;
    }
    a:nth-child(2) {
      margin-left: auto;
    }
    
`;

const PageFooterContent = styled.div`
  border-top: 1px solid #CED4DA;
  width: 100%;
  padding: 1.5rem 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 0;
  grid-template-areas:
      'a b';

  ${media.phone`
    display: block;
    > div:first-child {
      display: none;
    }
  `}
`;

const PageFooterLeft = styled.div`
  border-right: 1px solid #CED4DA;
  grid-area: a;
  align-self: start;
  height: 100%;
  ${media.tiny`
    width: 100%;
    border-right: none;
  `}
`;

const PageFooterRight = styled.div`
  grid-area: b;
  align-self: start;
  height: 100%;
  ${media.tiny`
    width: 100%;
  `}
`;

const PageFooterPadding = styled.div`
  margin: 0 auto;
  width: fit-content;
  width: -moz-fit-content;
  padding: 96px 0;
  position: relative;
  color: #0077FF;
  &.mozilla {
    color: #ff0900;
    svg g {
      stroke: #ff0900;
    }
  }
  &.skwiz {
    color: #485CDC;
    svg g {
      stroke: #485CDC;
    }
  }
  &.everyaction {
    color: #0077FF;
    svg g {
      stroke: #0077FF;
    }
  }
  &.amazon {
    color: #f86b01;
    svg g {
      stroke: #f86b01;
    }
  }
  ${media.tiny`
    padding: 1rem 0; 
    margin: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  `}
`;



const PageFooterTitle = styled.span`
  display: block;
  font-weight: 700;
  font-size: 24px;
  position: relative;
  width: fit-content;
  width: -moz-fit-content;
  padding-bottom: 4px;
  &:after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 0%;
    border-bottom: 2px solid #0077FF;
    transition: 0.4s;
  }
  &.mozilla {
    &:after {
      border-bottom: 2px solid #ff0900;
    }
  }
  &.skwiz {
    &:after {
      border-bottom: 2px solid #485CDC;
    }
  }
  &.everyaction {
    &:after {
      border-bottom: 2px solid #0077FF;
    }
  }
  &.amazon {
    &:after {
      border-bottom: 2px solid #f86b01;
    }
  }
`;



const PageFooterTitleContainer = styled.div`
  display: inline-block;
  ${media.small`
    font-size: 1rem;
  `}
`;

const PageFooterSubtitle = styled.span`
  text-transform: uppercase;
  font-family: ${fontMono};
  letter-spacing: 1px;
  font-size: 1rem;
  font-weight: 600;
`;

const LeftLink = styled.a`
  &.none {
    display: none;
  }
  svg {
    position: absolute;
    left: -56px;
    transition: left .25s;
    padding: 0;
    top: 106px;
    ${media.small`
      left: -48px;
    `}
    ${media.tiny`
      position: initial;
      display: inherit;
    `}
  }
  &:hover {
    span {
      &:after { width: 100%; }
    }
  }
  ${media.tiny`
    width: 100%;
    display: block;
  `}
`;

const RightLink = styled.a`
  &.none {
    display: none;
  }
  svg {
    position: absolute;
    right: -56px;
    transition: right .25s;
    padding: 0;
    top: 106px;
    ${media.small`
      right: -48px;
    `}
    ${media.tiny`
      position: initial;
      display: inherit;
    `}
  }
  &:hover {
    span {
      &:after { width: 100%; }
    }
  }
  ${media.tiny`
    width: 100%;
    display: block;
  `}
`;

const SVGContainer = styled.div`
  ${media.tiny`
    display: inline-block;
  `}
`;

const SiteFooter = styled.div`
  font-family: ${fontSans};
  border-top: 1px solid #CED4DA;
  padding: 1rem 0 .5rem 0;
  font-size: 15px;
  width: 100%;
  margin: 1rem auto 2rem auto;
  nav {
    float: right;
  }
  a {
      margin: 0 .5rem;
  }
  ${media.phone`
    width: 100%;
    margin: 0 auto 2rem auto;
    padding: 2rem 0 1rem 0;
  `}
  ${media.small`
    a { margin: .5rem 0; }
    nav {
      float: none;
      a {
        margin: 0 1rem 0 0;
      }
    }
  `}
`;

class PageFooter extends Component {
  render() {
    return (
        <footer>
            <ArticleFooter className={this.props.present}>
                <ContainerLarge>
                    <PageFooterContent>
                        <PageFooterLeft>
                            <LeftLink className={this.props.leftLink} href={this.props.leftLink}>
                                <PageFooterPadding className={this.props.theme}>
                                    <SVGContainer>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
                                          <g fill="none" fill-rule="evenodd" stroke="#07F" stroke-width="2">
                                            <circle cx="16" cy="16" r="15"/>
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15 21l-5-5 5-5"/>
                                            <path stroke-linecap="round" d="M11 16h11"/>
                                          </g>
                                        </svg>
                                    </SVGContainer>
                                    <PageFooterTitleContainer>
                                        <PageFooterSubtitle>{this.props.leftTitle}</PageFooterSubtitle>
                                        <PageFooterTitle className={this.props.theme}>{this.props.left}</PageFooterTitle>
                                    </PageFooterTitleContainer>
                                </PageFooterPadding>
                            </LeftLink>
                        </PageFooterLeft>
                        <PageFooterRight>
                            <RightLink className={this.props.rightLink} href={this.props.rightLink}>
                                <PageFooterPadding className={this.props.theme}>
                                    <PageFooterTitleContainer>
                                        <PageFooterSubtitle>{this.props.rightTitle}</PageFooterSubtitle>
                                        <PageFooterTitle className={this.props.theme}>{this.props.right}</PageFooterTitle>
                                    </PageFooterTitleContainer>
                                    <SVGContainer>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
                                          <g fill="none" fill-rule="evenodd" stroke="#07F" stroke-width="2">
                                            <circle cx="16" cy="16" r="15"/>
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M17 21l5-5-5-5"/>
                                            <path stroke-linecap="round" d="M11 16h11"/>
                                          </g>
                                        </svg>
                                    </SVGContainer>
                                </PageFooterPadding>
                            </RightLink>
                        </PageFooterRight> 
                    </PageFooterContent>
                    <SiteFooter>
                        <LinkCustom href="/">© Michael McCombie </LinkCustom>
                        <nav>
                            {/*<a href="https://spectrum.chat/users/michael" target="_blank" rel="noopener noreferrer">Spectrum</a><Interpunct>·</Interpunct>*/}
                            <LinkCustom href="https://twitter.com/michaelbuilds" target="_blank" rel="noopener noreferrer">Twitter</LinkCustom>
                            <LinkCustom href="https://github.com/michaelmccombie" target="_blank" rel="noopener noreferrer">Github</LinkCustom>
                            <LinkCustom href="https://www.instagram.com/mmccombie/" target="_blank" rel="noopener noreferrer">Instagram</LinkCustom>
                        </nav>
                    </SiteFooter>
                </ContainerLarge>
            </ArticleFooter>
            <OverlayFooter className={this.props.present + " " + this.props.theme}>
                <Link className={this.props.theme + " " + this.props.leftLink} to={{
                  pathname: this.props.leftLink,
                  state: { messageShown: false },
                  hash: 'present'
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
                      <g fill="none" fill-rule="evenodd" stroke="#07F" stroke-width="2">
                        <circle cx="16" cy="16" r="15"/>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 21l-5-5 5-5"/>
                        <path stroke-linecap="round" d="M11 16h11"/>
                      </g>
                    </svg>
                    <span>Previous</span>
                </Link>
                <Link className={this.props.theme + " " + this.props.rightLink} to={{
                  pathname: this.props.rightLink,
                  state: { messageShown: false },
                  hash: 'present'
                }}>
                    <span>Next</span> 
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
                      <g fill="none" fill-rule="evenodd" stroke="#07F" stroke-width="2">
                        <circle cx="16" cy="16" r="15"/>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M17 21l5-5-5-5"/>
                        <path stroke-linecap="round" d="M11 16h11"/>
                      </g>
                    </svg>
                </Link>
            </OverlayFooter>
        </footer>
    );
  }
}

export default PageFooter;



// WEBPACK FOOTER //
// src/components/PageFooter/PageFooter.js